<template>
    <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="72%" class="set_dia" :append-to-body="true">
        <iframe :src="tUrl" frameborder="0" style="width: 70vw; height: 94vh;" class="set_ifra"></iframe>
    </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
    data() {
        return {
            visible: true,
            tUrl: '',
            fileName: ''
        };
    },
    components: {

    },
    activated() {

    },
    mounted() {
    },
    methods: {
        init(fileName, filePath) {
            this.tUrl = ''
            this.fileName = fileName
            this.$nextTick(() => {
                this.visible = true;
            })
            this.viewFile(filePath)
            
        },
        viewFile(filePath) {
            $common.showLoading()
            $.ajax({
			url: this.$store.state.httpUrl + '/business/file/download?filePath=' + encodeURIComponent(filePath),
			type: 'post',
			dataType: 'blob',
			mimeType: 'text/plain; charset=x-user-defined',
			complete: (response) => {
				let rawLength = response['responseText'].length;
				if (rawLength == 0) {
                    $common.loadingHide()
                    this.$message.error("文件不存在！")
                    return;
				}
				$common.loadingHide()
				let array = new Uint8Array(new ArrayBuffer(rawLength));
				for (let i = 0; i < rawLength; i++) {
					array[i] = response['responseText'].charCodeAt(i) & 0xff;
				}
				this.tUrl = "/pdf/web/viewer.html?file=" + $common.getObjectURL(array, filePath);
			}
		});
        },
    }
}
</script>

<style lang="scss" scoped="scoped">
.set_dia { 
    margin-top:-112px !important;
    height: 1150px !important;
    position: fixed;
    top: 10;
    left: 0;
}
.set_ifra {
    margin-top:-22px;
    margin-left:-20px;
}

.set_dia::v-deep .el-dialog__header {
    height: 30px !important;
}

.set_dia::v-deep .el-dialog__headerbtn {
    top: 0px !important;
}
</style>
